const Strikeout = ({ striketext }) => {
  return (
    <p sx={{ variant: "text.graf", textDecoration: "line-through", paddingTop: ".47126rem" }}>
      {striketext}
    </p>
  )
}

export default Strikeout
